var FHSPROD = FHSPROD || new Object();
FHSPROD.labelme = FHSPROD.labelme || new Object();
FHSPROD.labelme.labels = [];
FHSPROD.labelme.settings = {"add_wrapper":0,"show_on_all_variant_images":0,"mobile_ratio":"0.75","max_viewpot_ratio":"0.75","viewpot_ratio":"0.65","max_mobile_screen_width":425,"support_mobile":1,"support_small_viewpot":1,"wrap_exact_img_tag":0,"show_collection_page":1,"show_product_page":1,"show_product_page_related":1,"stop_on_first_image":0,"scale_on_hover":1,"show_multiple_labels":1};

var loadScript = function(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
        script.onreadystatechange = function() {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        }
    } else {
        script.onreadystatechange = callback;
        script.onload = callback;
    }
    script.src = url;
    document.head.appendChild(script);
};
var labelInit = function(FHSPROD, jQuery) {
	
    //console.debug('labelInit()');
    jQuery.cookie = function(b, j, m) {
        if (typeof j != 'undefined') {
            m = m || {};
            if (j === null) {
                j = '';
                m.expires = -1;
            }
            var e = '';
            if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
                var f;
                if (typeof m.expires == 'number') {
                    f = new Date();
                    f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000));
                } else {
                    f = m.expires;
                }
                e = '; expires=' + f.toUTCString();
            }
            var l = m.path ? '; path=' + (m.path) : '';
            var g = m.domain ? '; domain=' + (m.domain) : '';
            var a = m.secure ? '; secure' : '';
            document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
        } else {
            var d = null;
            if (document.cookie && document.cookie != '') {
                var k = document.cookie.split(';');
                for (var h = 0; h < k.length; h++) {
                    var c = jQuery.trim(k[h]);
                    if (c.substring(0, b.length + 1) == (b + '=')) {
                        d = decodeURIComponent(c.substring(b.length + 1));
                        break;
                    }
                }
            }
            return d;
        }
    };
    FHSPROD.labelCookie = {
        name: 'fhs_label_me',
        setCookieStatus: function() { //installed, failed, re-installed, expired
            jQuery.cookie(this.name, 'installed');
        }
    };
    FHSPROD.labelCookie.setCookieStatus();
    if (FHSPROD.labelme.loadedApp === true) {
        return;
    }
    if ((typeof FHSPROD) == 'undefined') {
        var FHSPROD = {};
    }
    if ((typeof FHSPROD.labelme) == 'undefined') {
        FHSPROD.labelme = {};
    }
    if ((typeof FHSPROD.labelme.labels) == 'undefined') {
    	FHSPROD.labelme.labels = [];
    }
    if ((typeof FHSPROD.labelme.settings) == 'undefined') {
    	FHSPROD.labelme.settings = {"add_wrapper":0,"max_mobile_screen_width":425,"max_viewpot_ratio":0.75,"mobile_ratio":0.65
    		,"show_on_all_variant_images":0,"support_mobile":0,"support_small_viewpot":0,"viewpot_ratio":0.65};
    }
    FHSPROD.isDefined = function(obj) {
        return ((typeof obj == 'undefined') ? false : true);
    };
    FHSPROD.getPositionLeft = function(elem, strCssRule) {
        return 0;
    };
    FHSPROD.getPositionTop = function(elem, strCssRule) {
        return 0;
    };
    FHSPROD.getMarginW = function(elem, strCssRule) {
        var bordT = elem.outerWidth() - elem.innerWidth();
        var paddT = elem.innerWidth() - elem.width();
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return margT / 2;
    };
    FHSPROD.getMarginH = function(elem, strCssRule) {
        var bordT = elem.outerHeight() - elem.innerHeight();
        var paddT = elem.innerHeight() - elem.height();
        var margT = elem.outerHeight(true) - elem.outerHeight();
        return margT / 2;
    };
    FHSPROD.getPadding = function(elem, strCssRule) {
        var bordT = elem.outerWidth() - elem.innerWidth();
        var paddT = elem.innerWidth() - elem.width();
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return paddT;
    };
    FHSPROD.labelme.labelMain = function(variantId, image, pwidth, pheight, fhswrapper) {
	    //console.debug('labelMain()');
	    var imageParent = jQuery(image).parents(':not(a):not(ul):not(li)').first();
        imageParent.addClass("fhs-parent");
        
        if(FHSPROD.labelme.settings.add_wrapper == 1){
		    //jQuery(image).parents(':not(a)').eq(0).wrap(jQuery(fhswrapper));
	        if(jQuery(imageParent).parent().hasClass('fhs-wrapper') == false){
				jQuery(imageParent).wrap(jQuery(fhswrapper));
			}
	        //jQuery('.fhs-wrapper .fhs-image').hide();
        }else{
        	imageParent.css('position','relative');
        }
        
        var product = FHSPROD.labelme.product_main;
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variantId == variant.id) {
                break;
            }
        }
        var match_count = 0;
        var labels = FHSPROD.labelme.labels;
        for (var id in labels) {
            var label = labels[id];

            var condition = label.conditions;
            
            if (label.hide) {
                if (match_count > 0) {
                    continue;
                }
            }
            
            match = FHSPROD.labelme.matchLabel(product, label, pwidth, pheight, image, FHSPROD.labelme.showMatchLabelSingle);
            
            if (match) {
                match_count++;
            } else {
                continue;
            }
            
            
        }
    };
    FHSPROD.labelme.showMatchLabelSingle = function(product, label, pwidth, pheight, image, display_text ){
    	var imageParent = jQuery(image).parents(':not(a):not(ul):not(li)').first();
    	var labelNodes = jQuery(imageParent).find('.fhs-image[data-label-id=\"' + label.id + '\"]');
        if (labelNodes.length > 0) {
            labelNodes.first().show();
        } else {
        	var pos = label.position;
        	var style = 'position: absolute;';
    		
    		if('custom' == pos){
    			//top left already in div_style
    		}else if('topleft' == pos){
    			style += 'top:0%;left:0%;';
    		}else if('topright' == pos){
    			style += 'top:0%;right:0%;';
    		}else if('topcenter' == pos){
    			style += 'top:0%;left:'+(((pwidth-label.width)/2)/pwidth)*100 + '%'+';';
    		}else if('bottomleft' == pos){
    			style += 'bottom:0%;left:0%;';
    		}else if('bottomright' == pos){
    			style += 'bottom:0%;right:0%;';
    		}else if('bottomcenter' == pos){
    			style += 'bottom:0%;left:'+(((pwidth-label.width)/2)/pwidth)*100 + '%'+';';
    		}else if('leftcenter' == pos){
    			style += 'top:'+(((pheight-label.height)/2)/pheight)*100 + '%'+';left:0%;';
    		}else if('rightcenter' == pos){
    			style += 'top:'+(((pheight-label.height)/2)/pheight)*100 + '%'+';right:0%;';
    		}else if('center' == pos){
    			style += 'top:'+(((pheight-label.height)/2)/pheight)*100 + '%'+';left:'+ (((pwidth-label.width)/2)/pwidth)*100 + '%'+';';
    		}
    		
    		var newNode = jQuery('<div>');
    		jQuery(newNode).attr('data-label-id',label.id ).attr('class','fhs-image ' + label.css_class ).attr('style', label.div_style+style+ label.css_inline);
    		var textNode = jQuery('<div>');
    		jQuery(textNode).attr('style',label.text_style).text(display_text);    
    		jQuery(newNode).append(textNode);
            
    		//20 April 2017: CuongDV changed to append image to the imageParent instead of .fhs-wrapper
            //jQuery('.fhs-wrapper').append(newNode)
            //jQuery(imageParent).prepend(newNode);
    		
    		insertLabel(imageParent, label, pwidth, pheight, newNode, display_text);
        }
    };
    FHSPROD.labelme.matchLabel = function(product, label, pwidth, pheight, image, callback){
    	
    	var type = label.type;
        var display_text = label.display_text;
        var match = false;
        
    	if(label.apply_collections && label.apply_collections != ''){
        	if(product.collection_ids){
        		var ids = label.apply_collections.split(';');
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
            			match = true;
            			break;
            		}    
        		}
        	}
        }
        if(label.apply_products && label.apply_products.length > 0){
        	jQuery.each(label.apply_products, function(i, p) {
                if(p.handle === product.handle || p.id == product.id){
        			match = true;
        			return false;
        		}
            });
        }
        if(type == 5){ //5=out of stock
        	if(product.total_quantity == 0){
        		match = true;
        	}
        }else if(type == 4){ //4=low stock quantity
        	if ( product.total_quantity > 0 && product.total_quantity  <= label.low_stock_quantity  ) {
        		if(display_text.indexOf('$q') >= 0){
        			display_text = display_text.replace('$q', product.total_quantity);
        		}
        		match = true;
            }
        }else if(type == 3){ //1=new, 2=sale,3=others

        	if (label.expi_dt) {
        		var newDate = new Date();
                if (Date.parse(label.expi_dt) >= Date.parse(newDate.toString())) {
                    match = true;
                }
            }

        }else if(type == 2){
        	if(product.variants.length > 0){ //process variants
        		var subMatch = false; 
        		jQuery.each(product.variants, function(i, v){
        			if (v.compare_at_price_min && v.compare_at_price_min > 0 && v.price < v.compare_at_price_min) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price_min - v.price) / v.compare_at_price_min)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price_min - v.price) / v.compare_at_price_min)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price_min - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price_min - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }else if (v.compare_at_price_max && v.compare_at_price_max > 0 && v.price < v.compare_at_price_max) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price_max - v.price) / v.compare_at_price_max)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price_max - v.price) / v.compare_at_price_max)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price_max - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price_max - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }else if (v.compare_at_price && v.compare_at_price > 0  && v.price < v.compare_at_price) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price - v.price) / v.compare_at_price)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price - v.price) / v.compare_at_price)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }
        			
        			if(subMatch) {
        				return false;
        			}
        		});
        		
        		if(match == false) {
        			match = subMatch;
        		}
        	}else{ //product does not have any variant
        		if (product.compare_at_price_min && product.compare_at_price_min > 0 && product.price < product.compare_at_price_min) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price_min - product.price) / product.compare_at_price_min)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price_min - product.price) / product.compare_at_price_min)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price_min - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price_min - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }else if (product.compare_at_price_max && product.compare_at_price_max > 0 && product.price < product.compare_at_price_max) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price_max - product.price) / product.compare_at_price_max)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price_max - product.price) / product.compare_at_price_max)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price_max - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price_max - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }else if (product.compare_at_price && product.compare_at_price > 0  && product.price < product.compare_at_price) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price - product.price) / product.compare_at_price)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price - product.price) / product.compare_at_price)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }
        	}
        	
        }else if(type == 1){
        	
			 if (label.new_start_dt && label.new_end_dt) {
				 if(product.published_at_max && Date.parse(product.published_at_max.substring(0,10)) <= Date.parse(label.new_end_dt)){
					 match = true;
				 }
				 if (product.published_at_min && Date.parse(product.published_at_min.substring(0,10)) >= Date.parse(label.new_start_dt)) {
					 match = true;
				 }
				 if(product.published_at && Date.parse(product.published_at.substring(0,10)) >= Date.parse(label.new_start_dt)
						 && Date.parse(product.published_at.substring(0,10)) <= Date.parse(label.new_end_dt)){
					 match = true;
				 }
			 }
    	
    		if(label.new_threshold > 0){
				var newDate = new Date();
				newDate.setDate(newDate.getDate() - label.new_threshold);
				if(product.published_at && Date.parse(product.published_at.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
				if (product.published_at_min && Date.parse(product.published_at_min.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
			 }
        }
        if(match){
        	callback(product, label, pwidth, pheight, image, display_text);
        }
        return match;
    };
    FHSPROD.labelme.labelList = function(product, image, pwidth, pheight, fhswrapper) {

    	var imageParent = jQuery(image).parents(':not(a)').first();
        imageParent.addClass('fhs-parent');
        /*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
        	jQuery(p).parents(':not(a)').first().addClass('fhs-parent');
        });*/
        if(FHSPROD.labelme.settings.add_wrapper == 1){
        	jQuery(image).parents(':not(a)').eq(0).wrap(fhswrapper);
        	/*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
            	jQuery(p).parents(':not(a)').eq(0).wrap(fhswrapper);
            });*/
    	}else{
    		imageParent.css({'position': 'relative'});
    		/*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
            	jQuery(p).parents(':not(a)').first().css({
                    'position': 'relative'
                })
            });*/
    	}
        var match_count = 0;
        var labels = FHSPROD.labelme.labels;
        for (var id in labels) {
            var label = labels[id];
            var match = false;
            if (label.hide) {
                if (match_count > 0) {
                    continue;
                }
            }
            
            match = FHSPROD.labelme.matchLabel(product, label, pwidth, pheight, image, FHSPROD.labelme.showMatchLabelCollection);
            
            if (match) {
                match_count++
            } else {
                continue;
            }
            
        }
        return null;
    };
    function insertLabel(imageParent, label, pwidth, pheight, newNode, display_text){
    	
    	if(FHSPROD.labelme.settings && FHSPROD.labelme.settings.support_mobile == 1 && FHSPROD.labelme.settings.max_mobile_screen_width >= screen.width){
    		if(display_text != ''){
    			var style = jQuery(newNode).children()[0].style;
    			style.transform = style.transform + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.webkitTransform  = style.webkitTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.MozTransform   = style.MozTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.msTransform   = style.msTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.OTransform   = style.OTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.transformOrigin = '25% 25%';
    			/*var trxf = jQuery(newNode).css('transform');
    			jQuery(newNode).css({
    				  '-webkit-transform' : 'scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ' +trxf +'; ',
    				  '-moz-transform'    : 'scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ' +trxf +'; ',
    				  '-ms-transform'     : 'scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ' +trxf +'; ',
    				  '-o-transform'      : 'scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ' +trxf +'; ',
    				  'transform'         : 'scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ' +trxf +'; ' 
    			});*/
    			//jQuery(imageParent).append(newNode);
	    	}
    		if(label.mobile_width && label.mobile_width > 0){
				jQuery(newNode).css('width', label.mobile_width + 'px').css('height', label.mobile_height + 'px');
				
				jQuery(imageParent).append(newNode);
				
			}else if(FHSPROD.labelme.settings.mobile_ratio > 0){
				var newWidth = parseInt(label.width*FHSPROD.labelme.settings.mobile_ratio, 10);
				var newHeight = parseInt(label.height*FHSPROD.labelme.settings.mobile_ratio, 10);
				jQuery(newNode).css('width', newWidth + 'px').css('height', newHeight + 'px');
				
				label.mobile_width = newWidth;
				label.mobile_height = newHeight;
				
				jQuery(imageParent).append(newNode);
				
			}else{
				jQuery(imageParent).append(newNode);
			}
		}else if(FHSPROD.labelme.settings && FHSPROD.labelme.settings.support_small_viewpot == 1){
			
		    if(FHSPROD.labelme.settings.max_viewpot_ratio > 0 
		    		&& FHSPROD.labelme.settings.max_viewpot_ratio < (label.width/pwidth)){
		    	if(display_text != ''){
		    		var style = jQuery(newNode).children()[0].style;
		    		style.transform = style.transform + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.webkitTransform  = style.webkitTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.MozTransform   = style.MozTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.msTransform   = style.msTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.OTransform   = style.OTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.transformOrigin = '25% 25%';
		    		/*var trxf = jQuery(newNode).css('transform');
		    		jQuery(newNode).css({
	    				  '-webkit-transform' : 'scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ' +trxf +'; ',
	    				  '-moz-transform'    : 'scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ' +trxf +'; ',
	    				  '-ms-transform'     : 'scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ' +trxf +'; ',
	    				  '-o-transform'      : 'scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ' +trxf +'; ',
	    				  'transform'         : 'scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ' +trxf +'; '
	    			});*/
		    		//jQuery(imageParent).append(newNode);
		    	}
		    	
		    	if(label.viewpotWidth && label.viewportHeight){
					jQuery(newNode).css('width', label.viewpotWidth + 'px').css('height', label.viewpotHeight + 'px');
					jQuery(imageParent).append(newNode);
					
				}else{
			    	var newWidth = parseInt(label.width*FHSPROD.labelme.settings.viewpot_ratio, 10);
					var newHeight = parseInt(label.height*FHSPROD.labelme.settings.viewpot_ratio, 10);
					jQuery(newNode).css('width', newWidth + 'px').css('height', newHeight + 'px');
					
					label.viewpotWidth = newWidth;
					label.viewpotHeight = newHeight;
					
					jQuery(imageParent).append(newNode);
				}
		    }else{
		    	jQuery(imageParent).append(newNode);	
		    }
		}else{
			jQuery(imageParent).append(newNode);
		}
    };
    FHSPROD.labelme.showMatchLabelCollection = function(product, label, pwidth, pheight, image, display_text ){
    	var imageParent = jQuery(image).parents(':not(a)').first();
    	var labelNodes = jQuery(imageParent).find('.fhs-image[data-label-id=\"' + label.id + '\"]', image);
        if (labelNodes.length > 0) {
            labelNodes.first().show();
        } else {
            /*var newNode = '<div data-label-id="' + label.id + '" class="fhs-image ' + label.collectionImage.position + '" style="background-size: cover; background-image: url(' + label.collectionImage.image + '); width: ' + (label.collectionImage.label_width ? label.collectionImage.label_width : 30) + (label.collectionImage.fixed_size ? 'px' : '%') + '; height: ' + (label.collectionImage.label_height ? label.collectionImage.label_height : 30) + (label.collectionImage.fixed_size ? 'px' : '%') + ';position:absolute;">';*/
        	var pos = label.position;
    		var style = 'position: absolute;';
    		
    		if('custom' == pos){
    			//top left already in div_style
    		}else if('topleft' == pos){
    			style += 'top:0%;left:0%;';
    		}else if('topright' == pos){
    			style += 'top:0%;right:0%;';
    		}else if('topcenter' == pos){
    			style += 'top:0%;left:'+(((pwidth-label.width)/2)/pwidth)*100 + '%'+';';
    		}else if('bottomleft' == pos){
    			style += 'bottom:0%;left:0%;';
    		}else if('bottomright' == pos){
    			style += 'bottom:0%;right:0%;';
    		}else if('bottomcenter' == pos){
    			style += 'bottom:0%;left:'+(((pwidth-label.width)/2)/pwidth)*100 + '%'+';';
    		}else if('leftcenter' == pos){
    			style += 'top:'+(((pheight-label.height)/2)/pheight)*100 + '%'+';left:0%;';
    		}else if('rightcenter' == pos){
    			style += 'top:'+(((pheight-label.height)/2)/pheight)*100 + '%'+';right:0%;';
    		}else if('center' == pos){
    			style += 'top:'+(((pheight-label.height)/2)/pheight)*100 + '%'+';left:'+ (((pwidth-label.width)/2)/pwidth)*100 + '%'+';';
    		}
    		
    		var newNode = jQuery('<div>');
    		jQuery(newNode).attr('data-label-id',label.id ).attr('class','fhs-image ' + label.css_class ).attr('style', label.div_style+style+ label.css_inline);
    		var textNode = jQuery('<div>');
    		jQuery(textNode).attr('style',label.text_style).text(display_text);    
    		jQuery(newNode).append(textNode);
    		
    		insertLabel(imageParent, label, pwidth, pheight, newNode, display_text);
    		
            //jQuery('.fhs-wrapper', element).prepend(newNode)
			//jQuery('.fhs-wrapper .fhs-parent').prepend(newNode)
            /*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
            	jQuery(p).parents(':not(a)').first().append(newNode)
            });*/
        }
    };
	function loadCSS(href) {
		var cssLink = $("<link rel='stylesheet' type='text/css' href='"+href+"'>");
		jQuery("head").append(cssLink);
	};
	function loadFont(fontName) {
		loadCSS('https://fonts.googleapis.com/css?family=' + fontName);
	};
    function findProductListImages() {
    	//04 April 2017: CuongDV remove below criteria to allow display label on related products
    	//:not(.related-products a[href*=\"/products/\"]) 
        var productImages = jQuery('a[href*=\"/products/\"]:not([href*=\".jp\"]):not(form a[href*=\"/products/\"]):not([href*=\".JP\"]):not([href*=\".png\"]):not([href*=\".PNG\"])').has('img[src*=\"/products/\"], img[src*=\"/no-image\"]');
        /*var products = {};
        productImages.each(function(index, product) {
            var splits = jQuery(product).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            products[handle] = product
        });
        return products*/
        return productImages;
    };

    function findProductMainImages() {
    	var img_src = '';
    	var first_src = '';
    	if(FHSPROD.labelme.product_main.images[0]){
    		first_src = FHSPROD.labelme.product_main.images[0].src;
    		img_src = FHSPROD.labelme.product_main.images[0].src;
    		img_src = img_src.substr(0, img_src.indexOf('.'));
    	}
    	
    	var images = [];
    	var allImages = jQuery('img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".jp\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".JP\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".png\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".PNG\"]');
    	if(FHSPROD.labelme.settings.show_on_all_variant_images == 0 && img_src != '')
    	{
    		//find the first image
    		var firstImages = jQuery('img[src*=\"'+img_src+'\"]');
    		if(firstImages.length > 0){
				if(allImages.length > 0 && firstImages[0].src == allImages[0].src){
					images = firstImages[0];	
				}if (allImages.length > 0 ){
					images = allImages[0];
				}else{
					images = firstImages[0];
				}    			
    		}else if (allImages.length > 0 ){
				images = allImages[0];
			}
			/*if(firstImages.length > 0 && allImages.length > 0 && allImages[0].src != firstImages[0].src){
				images = allImages;
			}*/
    	}else{ //display on all images
			var i;
			var pimage;
			var matches;
			jQuery(allImages).each(function(i, aimage){
				for(i=0; i<FHSPROD.labelme.product_main.images.length; i++){
					pimage = FHSPROD.labelme.product_main.images[i];
					matches = pimage.src.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
					if(matches[1].length > 0){
						if( aimage.src.indexOf(matches[1]) > 0){
							images.push(aimage);
						}
					}
				}
			});
    	}
		/*var screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        var maxWidth = 0;
        var mainImage;
        jQuery(images).each(function(index, image) {
            var currentWidth = image.width;
            if (currentWidth > maxWidth && currentWidth <= screenWidth) {
                maxWidth = currentWidth;
                mainImage = image
            }
        });
        return jQuery(mainImage)*/	
    	return images;
    };

    function getVariantId() {
        var variantId = null;
		return variantId;
		// if(Shopify.urlParam){
			// variantId= Shopify.urlParam('variant');
		// }
        // if (!variantId) {
            // var elem = document.getElementById(Shopify.OptionSelectors.domIdPrefix);
            // if (!elem) {
                // return false
            // }
            // var option = elem.querySelector('[selected]');
            // if (!option) {
                // return false
            // }
            // variantId = option.value
        // }
        // return variantId
    };
    
    function executeQuery(arrProductImages, queryUrl){

    	/*jQuery.getJSON(queryUrl, function(json) {
	            jQuery.each(json.results, function(i, product) {
	            	FHSPROD.labelme.products[product.handle] = product;
	            });
	            showLabels(arrProductImages)
    		} );*/
    	jQuery.ajax({
            url: queryUrl,
            dataType: 'text',
            type: 'post',
            success: function(text) {
            	 //console.debug(text);
            	try{
            	 json = JSON.parse(text.substring(text.indexOf('START_FHSPROD')+13, text.lastIndexOf('END_FHSPROD')));
            	//console.debug(json)
                jQuery.each(json.results, function(i, product) {
                	FHSPROD.labelme.products[product.handle] = product;
                });
                
                showLabels(arrProductImages);
            	}catch(err){
            		console.debug(text);
            		console.debug(err);
            	}
    		}
    	});
    	
    	/*jQuery.ajax({
            url: queryUrl,
            success: function(json) {
            	console.debug(json)
                jQuery.each(json.results, function(i, product) {
                	FHSPROD.labelme.products[product.handle] = product;
                });
                showLabels(arrProductImages)
    		}
    	});*/
    	
    	
    };
    FHSPROD.labelme.productImages = {};
    function queryProduct(arrProductImages){
    	var fullQuery = "";
        var idx = 0;
        var startSlice = 0;
    	arrProductImages.each(function(index, product) {
            var splits = jQuery(product).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            if(handle.indexOf('#') > 0){
            	handle = handle.substring(0, handle.indexOf('#'));
            }
            
            if (fullQuery.length > 0) {
                fullQuery += " OR ";
            }
            fullQuery += "handle:\"" + handle + "\"";
            idx++;
            if (idx >= 5) {
                //jQuery.getScript('/search.js?q=' + fullQuery + '&view=fhsprod-labelme-json');
            	fullQuery = '/search.js?view=fhsprod-labelme-json&q=' + fullQuery;
            	executeQuery(arrProductImages.slice(startSlice, startSlice+idx), fullQuery);
            	startSlice += idx;
            	fullQuery = "";
            	idx = 0;
            }
        });
        if (idx > 0) {
            //jQuery.getScript('/search.js?q=' + fullQuery + '&view=fhsprod-labelme-json')
        	fullQuery = '/search.js?view=fhsprod-labelme-json&q=' + fullQuery;
        	executeQuery(arrProductImages.slice(startSlice, startSlice+idx), fullQuery);
        	fullQuery = "";
        }
    };
    
    function showLabels(arrProductImages){
    	arrProductImages.each(function(index, productImage) {
            var splits = jQuery(productImage).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            if(handle.indexOf('#') > 0){
            	handle = handle.substring(0, handle.indexOf('#'));
            }
            
            //save productImage[handle] for future use
            if (!FHSPROD.labelme.productImages.hasOwnProperty(handle)) {
            	FHSPROD.labelme.productImages[handle] = productImage;
            }
            
            var image = jQuery('img', productImage);
            
            $productImage = jQuery(productImage);

			var h = $productImage.height();
            var w = $productImage.width();
            
            if( h == 0 && image.length > 0){
            	h = image[0].height;	
            }
            if(w == 0 && image.length > 0){
            	w =image[0].width;	
            }

            var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-collection\">').css({
            	//TODO optional fix width
                //width: $productImage.width(),
                //height: $productImage.height(),
                'margin-left': FHSPROD.getMarginW($productImage),
                'margin-right': FHSPROD.getMarginW($productImage),
                'margin-top': FHSPROD.getMarginH($productImage),
                'margin-bottom': FHSPROD.getMarginH($productImage),
                'position': 'relative',
                padding: FHSPROD.getPadding($productImage),
            });
            
            var product = FHSPROD.labelme.products[handle];
            if(product){
            	FHSPROD.labelme.labelList(product, productImage, w, h, $plcontainer);
            }
        });
    };
    function addClassCss() {
    	jQuery('<style>')
	    .attr('type', 'text/css')
	    .html('div.fhs-image:hover{ -webkit-transition: all 200ms ease-in!important;'
	    	+'-webkit-transform: scale(1.1)!important;'
	        +'-ms-transition: all 200ms ease-in!important;-ms-transform: scale(1.1)!important;-moz-transition: all 200ms ease-in!important;-moz-transform: scale(1.1)!important;'
	        +'transition: all 200ms ease-in!important;transform: scale(1.1)!important;}'
	        +''
	    )
	        .appendTo('head');
	};
	
    jQuery(document).ready(function() {
    	addClassCss();
        jQuery('div.fhs-wrapper').remove();
        //load fonts
        jQuery.each(FHSPROD.labelme.labels, function(i, label) {
            if(label.font_name){
            	loadFont(label.font_name);
            }
        });
        if (FHSPROD.labelme.pg == 'product') {
            //console.debug('Go product page');
        	var images = findProductMainImages();
            //var image = findProductMainImages();
			
			jQuery(images).each(function(i, image){
				var $plcontainer ;
				
				if (image) {
					$plcontainer = jQuery('<div class=\"fhs-wrapper fhs-product\">').css({
						//width: image.width(),
						//height: image.height(),
						'margin-left': FHSPROD.getMarginW(jQuery(image)),
						'margin-right': FHSPROD.getMarginW(jQuery(image)),
						'margin-top': FHSPROD.getMarginH(jQuery(image)),
						'margin-bottom': FHSPROD.getMarginH(jQuery(image)),
						'position': 'relative',
						padding: FHSPROD.getPadding(jQuery(image)),
					});
					
					var variantId = getVariantId();
					if (!variantId) {
						variantId = FHSPROD.labelme.product_main.variants[0].id;
					}
					FHSPROD.labelme.labelMain(variantId, jQuery(image), jQuery(image).width(), jQuery(image).height(), $plcontainer);
				}
				/*jQuery(window).resize(function() {
					var images = findProductMainImages();
					jQuery(images).each(function(i, image){
						jQuery('.fhs-product').css({
							//TODO optional fix width
							//width: image.width(),
							//height: image.height(),
							'margin-left': FHSPROD.getMarginW(jQuery(image)),
							'margin-right': FHSPROD.getMarginW(jQuery(image)),
							'margin-top': FHSPROD.getMarginH(jQuery(image)),
							'margin-bottom': FHSPROD.getMarginH(jQuery(image)),
							'position': 'relative',
							padding: FHSPROD.getPadding(jQuery(image)),
						});
					});
				});
				jQuery('.single-option-selector').change(function() {
					if (!FHSPROD.isDefined(Shopify.urlParam) || !FHSPROD.isDefined(Shopify.OptionSelectors)) {
						//console.log('No Shopify.OptionSelectors');
						return;
					}
					var variantId = getVariantId();
					if (!variantId) {
						//console.log('no variantId');
						return false;
					}
					FHSPROD.labelme.labelMain(variantId, image, image.width(), image.height(), $plcontainer);
				});*/
			});
        }
        
        if (FHSPROD.labelme.pg == 'collection' || FHSPROD.labelme.pg == '' || FHSPROD.labelme.pg == 'product') {
            var arrProductImages = findProductListImages();
            if(typeof FHSPROD.labelme.product_list === 'undefined')
            	FHSPROD.labelme.product_list = [];
            //FHSPROD.labelme.productImages = productImages;
            //console.debug('Go collection page');
            FHSPROD.labelme.products = {};
            if(typeof FHSPROD_product_list !== 'undefined'){
            	FHSPROD.labelme.product_list = FHSPROD_product_list;
            }
            
            if(FHSPROD.labelme.product_list){
	            jQuery.each(FHSPROD.labelme.product_list, function(i, product) {
	                FHSPROD.labelme.products[product.handle] = product;
	            });
            }
            if(FHSPROD.labelme.product_front){
	            jQuery.each(FHSPROD.labelme.product_front, function(i, product) {
	                FHSPROD.labelme.products[product.handle] = product;
	            });
            }

            if(FHSPROD.labelme.product_list.length == 0){
            	queryProduct(arrProductImages);
            }else{
            	showLabels(arrProductImages);
            }
            

            /*jQuery(window).resize(function() {
                var arrProductImages = findProductListImages();
                arrProductImages.each(function(index, productImage) {
                    $productImage = jQuery(productImage);
                    jQuery('.fhs-collection', productImage).css({
                    	//TODO optional fix width
                        //width: $productImage.width(),
                        //height: $productImage.height(),
                        'margin-left': FHSPROD.getMarginW($productImage),
                        'margin-right': FHSPROD.getMarginW($productImage),
                        'margin-top': FHSPROD.getMarginH($productImage),
                        'margin-bottom': FHSPROD.getMarginH($productImage),
                        'position': 'relative',
                        padding: FHSPROD.getPadding($productImage),
                    })
                });
            });*/
        }
		jQuery('.fhs-image').css('display','block');
    }) //end document.ready
};
if (FHSPROD.labelme.loadedJs === true) {
    FHSPROD.labelme.jQuery(document).ready(function() {
        labelInit(FHSPROD, FHSPROD.labelme.jQuery);
    })
} else {
    if (typeof jQuery === 'undefined') {
        loadScript('//code.jquery.com/jquery-1.11.1.min.js', function() {
            FHSPROD.jQuery = jQuery.noConflict(true);
            FHSPROD.jQuery(document).ready(function() {
                labelInit(FHSPROD, FHSPROD.jQuery);
            })
        })
    } else {
        jQuery(document).ready(function() {
            labelInit(FHSPROD, jQuery);
        })
    }
}